(function () {
  const SWIPER_OPTS = {
    slidesPerView: 1.2,
    freeMode: false,
    slideToClickedSlide: true,
    spaceBetween: 16,
    mousewheel: true,
     breakpoints: {
        420: {
          slidesPerView: 1.1,
        },

        960: {
          slidesPerView: 'auto',
        },
        1024: {
          slidesPerView: 1.1,
        },
        1300: {
          slidesPerView: 1.2,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
  };

  function initIn(container) {
    if (!container || container.dataset.swiperInit === "1") return;
    const el = container.querySelector(".complementary-widget-wrapper");
    if (!el || el.querySelectorAll(".swiper-slide").length === 0) return;

    container.dataset.swiperInit = "1";
    // guard against theme re-renders
    if (!el.swiper) new Swiper(el, SWIPER_OPTS);
  }

  function initAll() {
    document
      .querySelectorAll("product-recommendations.product-complementary")
      .forEach(initIn);
  }

  // 1) Try on DOM ready and on full load
  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("load", initAll);

  // 2) Shopify Theme Editor hot-loads sections
  window.addEventListener("shopify:section:load", initAll);

  // 3) Observe `<product-recommendations>` innerHTML replacement
  const observePR = (pr) => {
    new MutationObserver(() => initIn(pr)).observe(pr, { childList: true, subtree: true });
  };

  // observe existing and future PR nodes
    document.querySelectorAll("product-recommendations.product-complementary").forEach(observePR);
    new MutationObserver((ml) => {
      ml.forEach((m) =>
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches?.("product-recommendations.product-complementary")) observePR(n);
          n.querySelectorAll?.("product-recommendations.product-complementary").forEach(observePR);
        })
      );
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('click', async (e) => {
    if (!e.target.matches('.add-to-cart-link')) return;

    const id = e.target.dataset.id;
  const drawer = document.querySelector('cart-drawer');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id, quantity: 1 }],
        sections: 'cart-drawer'
      })
    });

    console.log('Added to cart!');

  const data = await response.json();

  // 2. update counter
  updateCartBubble(); 

  // 3. update Drawer
  if (data.sections && drawer) {
    const html = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
    const newInner = html.querySelector('.drawer__inner');
    
    if (newInner) {
      drawer.querySelector('.drawer__inner').innerHTML = newInner.innerHTML;
      // Прибираємо клас порожнього кошика, якщо він був
      drawer.classList.remove('is-empty');
    }

    // 4. open Drawer
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('active'); 
    }
  }
    

  });
 function updateCartBubble() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          let bubble = document.querySelector('.cart-count-bubble');
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (!bubble && cartIcon) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              cartIcon.appendChild(bubble);
          }
          if (bubble) {
              bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} Artikel</span>`;
          }
        });
    }


})();